import { combineReducers } from 'redux';

import byId, { getEventsById } from './byId';
import currentId, { getEventsCurrentId } from './currentId';
import isFetching from './isFetching';
import latest from './latest';
import status from './status';

const events = combineReducers({
  byId,
  currentId,
  isFetching,
  latest,
  status,
});

export default events;

export const getCurrentEvent = (state) => {
  return getEventsById(state)[getEventsCurrentId(state)];
};


// WEBPACK FOOTER //
// ./src/reducers/events/index.js